/*
 * File: 多语言日期格式化
 * File Created: 2021-05-14 5:59:27 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-05-14 5:59:39 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

export default {
  'zh-CN': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    shortMonthDay: {
      month: 'short',
      day: 'numeric'
    }
  },
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    shortMonthDay: {
      month: 'short',
      day: 'numeric'
    }
  },
  'ja-JP': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    shortMonthDay: {
      month: 'short',
      day: 'numeric'
    }
  }
}
